<template>
  <div class="container">
    <div class="attensi">
      <img class="logo" src="@/assets/img/attensi_hex_logo.svg" alt="" />
    </div>
  </div>
</template>

<script>
/**
 * @deprecated - use BaseLoading component instead
 */
export default {}
</script>

<style scoped>
.container {
  overflow: hidden;
}

.attensi {
  width: 100px;
  height: 100px;
  aspect-ratio: 1/1;
  object-fit: contain;
}

.logo {
  width: 100px;
  height: 100px;
  animation: spinner 5000ms ease-in-out infinite;
}

@keyframes spinner {
  0%,
  100% {
    transform: rotate(0deg);
  }
  33% {
    transform: rotate(180deg);
  }
  66% {
    transform: rotate(360deg);
  }
}
</style>
